import section1 from './pc/section-1';
import section2 from './pc/section-2';
import section3 from './pc/section-3';
import section4 from './pc/section-4';
import section5 from './pc/section-5';
import section6 from './pc/section-6';
import BgmSound from "./pc/bgmSound";
var page = promokit.page({
    type: 'fullpage-vertical',

    game: 'lineage',

    menu: true,

    cnb: true,

    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'day',
            key: 'INDEX_WEB_VISIT_200722_lancer',
            value: false
        },
        home: true,
        update: true,
        sns: true
    },

    footer: {
        fixed: true,
    },

    components: [
        section1,
        section2,
        section3,
        section4,
        section5,
        section6,
    ],
});


 var bgm = new BgmSound({
     url:"https://vod.plaync.com/lineage/remaster/Lineage_remastered_lancer_bgm.mp4",   // 오디오 url
     volume:0.7, // 볼륨
     setPlay: false
 })
section1.mainLayer1.on('openstart',()=>{
    bgm.get() && bgm.set(false);
})
section1.mainLayer1.on('closestart',()=>{
    bgm.get()?bgm.set(true):bgm.set(false);
})

section1.mainLayer2.on('openstart',()=>{
    bgm.get() && bgm.set(false);
})
section1.mainLayer2.on('closestart',()=>{
    bgm.get()?bgm.set(true):bgm.set(false);
})



section3.videoPlayer.on("play", ()=>{
    bgm.get() && bgm.set(false);
})

section3.videoPlayer.on("stop", ()=>{
    bgm.get()?bgm.set(true):bgm.set(false);
})

section3.videoPlayer.on("pause", ()=>{
    bgm.get()?bgm.set(true):bgm.set(false);
})

section3.videoPlayer.on("ended", ()=>{
    bgm.get()?bgm.set(true):bgm.set(false);
})


promokit.preload();


// WEBPACK FOOTER //
// ./src/js/index.js